$(document).ready(function () {
    // console.log("totals_choiryear.js loaded");

    function intVal(group, selector) {
        return parseInt(group.find(selector).val(), 10) || 0;
    }

    function updateTotals(group) {
        var count_m = intVal(group, '#count_m');
        var count_f = intVal(group, '#count_f');
        var count_nb = intVal(group, '#count_nb');
        var count_by_gender = count_m + count_f + count_nb;

        var count_voices = intVal(group, '#count_soprano') + intVal(group, '#count_alto')
            + intVal(group, '#count_tenor') + intVal(group, '#count_bass');

        var count_singers = count_by_gender;
        group.find('.count_singers').html(count_singers);

        // the voice distribution must add up to the singers total
        var mismatch = count_voices > 0 && count_voices !== count_singers;
        group.find('.voices-mismatch').toggle(mismatch);
        group.find('.voices-sum').html(count_voices);
        group.find('.singers-sum').html(count_by_gender);

        var count_staff = intVal(group, '#count_staff');
        // var count_drivers = intVal(group, '#count_drivers');
        var count_musicians = intVal(group, '#count_musicians');

        // var count_support = count_staff + count_drivers + count_musicians;
        var count_support = count_staff + count_musicians;
        var count_total = count_singers + count_support;
        //console.log("Total count: " + count_total);
        group.find('.count_total').html(count_total);

        // the staff rooms must offer one bed per staff member (single = 1, double = 2)
        var rooms_capacity = intVal(group, '#count_staff_rooms_single') + 2 * intVal(group, '#count_staff_rooms_double');
        var rooms_mismatch = rooms_capacity > 0 && rooms_capacity !== count_support;
        group.find('.rooms-mismatch').toggle(rooms_mismatch);
        group.find('.rooms-sum').html(rooms_capacity);
        group.find('.staff-sum').html(count_support);

        // Update diet counts
        var count_diet = intVal(group, '#count_diet_meat')
            + intVal(group, '#count_diet_meat_no_gluten')
            + intVal(group, '#count_diet_meat_no_lactose')
            + intVal(group, '#count_diet_meat_no_gluten_lactose')
            + intVal(group, '#count_diet_vegetarian')
            + intVal(group, '#count_diet_vegetarian_no_gluten')
            + intVal(group, '#count_diet_vegetarian_no_lactose')
            + intVal(group, '#count_diet_vegetarian_no_gluten_lactose')
            + intVal(group, '#count_diet_vegan')
            + intVal(group, '#count_diet_vegan_no_gluten');
        group.find('.count_diet').html(count_diet);

        var count_diet_difference = count_total - count_diet;
        group.find('.count_diet_difference').html(count_diet_difference);

        group.find('.count_diet_difference_icon').html(count_diet_difference === 0 ? '<span class="text-success">&#x2714;</span>' : '<span class="text-danger">&#10008;</span>');
    }

    $(document).on('change', '#count_m, #count_f, #count_nb, #count_soprano, #count_alto, #count_tenor, #count_bass, #count_staff, #count_drivers, #count_musicians, #count_staff_rooms_single, #count_staff_rooms_double, #count_diet_meat, #count_diet_meat_no_gluten, #count_diet_meat_no_lactose, #count_diet_meat_no_gluten_lactose, #count_diet_vegetarian, #count_diet_vegetarian_no_gluten, #count_diet_vegetarian_no_lactose, #count_diet_vegetarian_no_gluten_lactose, #count_diet_vegan, #count_diet_vegan_no_gluten', function () {
        // console.log("Change detected in totals_choiryear.js");
        updateTotals($(this).closest('.year-group'));
    });

    // show a stored voices/gender mismatch right away, without waiting for an edit
    $('.year-group').each(function () {
        if ($(this).find('#count_soprano').length) {
            updateTotals($(this));
        }
    });

});
